Promise.all([import('./site-mobile-menu.scss')]).then(() => {
  $('.widget.site-mobile-menu').each(function (i, el) {
    $(el).data('widget', new SiteMobileMenu(el))
  })
})
class SiteMobileMenu {
  constructor(el) {
    if (process.env.NODE_ENV === 'development') {
      console.log('SiteMobileMenu init', self)
    }

    this.el = el
    this.navbarBreakpoint = 794 // see tailwind.config
    this.mobileMenuToggles = document.querySelectorAll('.js-toggle-site-mobile-menu')
    this.submenuTriggers = this.el.querySelectorAll('.js-toggle-submenu')

    // If body has class 'show-mobile-menu' run open() to correctly show the menu.
    // NOTE this could be used to show menu on page load for easy development.
    if (document.body.classList.contains('show-mobile-menu')) {
      this.open()
    }

    this.bindEvents()
  }

  bindEvents() {
    window.addEventListener('resize', () => {
      if (window.innerWidth >= this.navbarBreakpoint) {
        this.close()
      }
    })

    // Mobile menu events
    // ====================================
    this.mobileMenuToggles.forEach((toggle) => {
      toggle.addEventListener('click', (event) => {
        let isMobileMenuOpen = this.el.getAttribute('aria-hidden') === 'false';
        if (isMobileMenuOpen) {
          this.el.setAttribute('aria-hidden', 'true');
          if (document.getElementsByClassName('smartbanner')) {
            $('.smartbanner').removeAttr('hidden')
          }
          if (document.getElementsByClassName('alert-banner')) {
            $('.widget.alert-banner').removeAttr('hidden')
          }

          this.close();
        }
        else {
          this.el.setAttribute('aria-hidden', 'false')
          if (document.getElementsByClassName('smartbanner')) {
            $('.smartbanner').attr('hidden', 'hidden')
          }
          if (document.getElementsByClassName('alert-banner')) {
            $('.widget.alert-banner').attr('hidden', 'hidden')
          }

          this.open(event.currentTarget);
        }
      })
    })

    this.el.addEventListener('transitionend', (event) => {
      // NOTE 'transitionend' fires for each property that is transitioned.
      // For example, if transitioning both 'opacity' and 'transform', this addEventListener callback will fire twice.

      // If the mobile menu was hidden, then close all its submenus.
      if (event.propertyName === 'opacity') {
        let hidden = this.el.getAttribute('aria-hidden')
        if (hidden === 'true') {
          // Add class 'hidden' to ensure the page content below the container to be accessible/clickable.
          // NOTE: This is required if the element is not removed from the DOM, or positioned off-screen.
          this.el.classList.add('hidden')
          this.closeAllSubmenus()
        }
      }
    })

    this.submenuTriggers.forEach((triggerEl) => {
      triggerEl.addEventListener('click', (event) => {
        event.preventDefault()
        console.log('submenu trigger clicked', event.currentTarget)

        if (triggerEl.getAttribute('aria-expanded') === 'true') {
          this.closeSubmenu(triggerEl)
        } else {
          this.openSubmenu(triggerEl)
        }
      })
    })
  }

  // Mobile menu methods
  // ====================================
  open(toggle) {
    // Prevent scrolling of the page content when the mobile menu is open
    document.body.classList.add('overflow-hidden', 'show-mobile-menu')

    // Remove class 'hidden' to allow menu to show.
    this.el.classList.remove('hidden')

    // Update aria attributes after to show the menu.
    // NOTE: We need the setTimeout to ensure CSS transitions work after removing the class 'hidden' from the same element.
    setTimeout(() => {
      this.el.setAttribute('aria-hidden', 'false')
      // toggle.setAttribute('aria-expanded', 'true')
    }, 0)
  }

  close() {
    this.el.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('overflow-hidden', 'show-mobile-menu')
  }

  openSubmenu(triggerEl) {
    triggerEl.setAttribute('aria-expanded', 'true')
    triggerEl.closest('.has-submenu')?.classList.add('has-expanded')

    const ariaControls = triggerEl.getAttribute('aria-controls')
    console.log('openSubmenu', ariaControls)
    this.submenuTriggers.forEach((trigger) => {
      if (trigger.getAttribute('aria-controls') === ariaControls) {
        trigger.setAttribute('aria-expanded', 'true')
      }
    })

    const menuElem = this.el.querySelector(`#${ariaControls}`)
    menuElem.setAttribute('aria-hidden', 'false')
  }

  closeSubmenu(triggerEl) {
    console.log('closeSubmenu', triggerEl)
    triggerEl.setAttribute('aria-expanded', 'false')
    triggerEl.closest('.has-submenu')?.classList.remove('has-expanded')

    const ariaControls = triggerEl.getAttribute('aria-controls')
    this.submenuTriggers.forEach((trigger) => {
      if (trigger.getAttribute('aria-controls') === ariaControls) {
        trigger.setAttribute('aria-expanded', 'false')
      }
    })

    const menuElem = this.el.querySelector(`#${ariaControls}`)
    menuElem.setAttribute('aria-hidden', 'true')
  }

  closeAllSubmenus() {
    this.submenuTriggers.forEach((triggerEl) => {
      this.closeSubmenu(triggerEl)
    })
  }
}
